export interface HeaderMenuItemType {
    label: string;
    name: string;
    icon?: string;
    items?: HeaderMenuItemType[];
    href?: string;
    target?: string;
    download?: string;
}
